module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/toggle-d1d1411b62e2732904b7a53677c1607d.svg";